import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./SecretFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import SecretFormStepOne from "./SecretFormSteps/SecretFormStepOne";
import SecretFormStepTwo from "./SecretFormSteps/SecretFormStepTwo";
import { useTechnicians } from "../../../../Hooks/useTechniciansHook/useTechnicians";

const SecretForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const { allTechnicians } = useTechnicians();

  const normalizeRepresentativeLabel = (el) => {
    const fullName = [el?.name, el?.lastname].filter(Boolean).join(" ");

    return [fullName, el?.email, el?.phoneNumber].filter(Boolean).join(" · ");
  };
  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        customerServiceRepresentative: _initialValues
          ?.customerServiceRepresentative?.uuid
          ? {
              value: _initialValues.customerServiceRepresentative.uuid,
              name: `${_initialValues.customerServiceRepresentative.firstName} ${_initialValues.customerServiceRepresentative.lastName}`,
              uuid: _initialValues.customerServiceRepresentative.uuid,
            }
          : null,
        clientRepresentative: _initialValues?.clientRepresentative
          ? {
              label: normalizeRepresentativeLabel(
                _initialValues.clientRepresentative,
              ),
              uuid: _initialValues.clientRepresentative.uuid,
            }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="SecretForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <SecretFormStepOne
                  {...formProps}
                  {...props}
                  allTechnicians={allTechnicians}
                />
                <SecretFormStepTwo
                  {...formProps}
                  {...props}
                  allTechnicians={allTechnicians}
                />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default SecretForm;
